<div
    class="bg-primary-color flex justify-center items-center text-white text-small-medium py-2.5 mob:flex-wrap mob:px-15px text-center"
>
    <img [ngSrc]="'sparkles' | asset: 'header'" alt="sparkles" width="24" height="24" />
    <span class="ml-2.5" i18n> Discover our features! </span>
    <span
        routerLink="/features"
        class="underline ml-5 cursor-pointer"
        aria-label="Learn more"
        i18n="@@button-lear-more"
    >
        Learn More
    </span>
</div>
<companyid-content-wrapper
    class="border border-solid border-gray-2 !static"
    classNames="w-full h-74px mob:px-15px tab:px-15px bg-white py-2.5 gap-25px flex w-full mob:gap-0 items-center mob:justify-between"
>
    <companyid-mobile-navbar [navigation]="headerNavigations" class="desk:hidden flex items-center" />

    <div class="flex gap-25px items-center mob:gap-0">
        <companyid-logo class="mob:m-auto mob:max-w-[130px]" />

        <div class="flex gap-15px mob:hidden tab:hidden">
            @for (header of headerNavigations; track header.title) {
                <a
                    [routerLink]="header.route"
                    routerLinkActive="text-primary-color"
                    class="button-ghost-gray mob:hidden tab:hidden"
                >
                    {{ header.title }}
                </a>
            }
        </div>
    </div>
    <div class="tab:ml-auto desk:ml-auto flex items-center gap-15px">
        <companyid-language-switcher class="mob:hidden" />

        <a class="button-primary-outline" routerLink="/contact-us" i18n="@@button-get-demo"> Get demo </a>
    </div>
</companyid-content-wrapper>
